export enum PropertyInquirySource {
  ZILLOW = 'Zillow',
  MANUALLY_ADDED = 'Manually Added',
  FACEBOOK = 'Facebook',
  /** The renter applied through a seat's apply link; the application went out with the lead, or waits for the owner. */
  APPLY_LINK = 'Apply Link',
}
